import { Button, InputAdornment, Stack, TextField } from "@mui/material";
import Iconify from "../../../../minimals/components/iconify";
import { Dispatch, SetStateAction, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AddEditContactContext } from "../../contact/addEditContact/AddEditContactContext";
import { CompanyContext } from "../CompanyContext";
import useResponsive from "../../../../minimals/hooks/useResponsive";

interface IProps {
  setSearchKeywords: Dispatch<SetStateAction<string | undefined>>;
}

export default function SearchSection(props: IProps) {
  const { setSearchKeywords } = props;
  const { company } = useContext(CompanyContext);
  const { setSelectedCompany } = useContext(AddEditContactContext);
  const navigate = useNavigate();
  const isMobile = useResponsive("down", "md");

  const handleAddMember = () => {
    setSelectedCompany(company || null);
    navigate(`../phonebook/create-contact?companyId=${company?.id || ""}`);
  };

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <TextField
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Iconify icon="eva:search-fill" />
            </InputAdornment>
          )
        }}
        placeholder="Search..."
        size={isMobile ? "small" : "medium"}
        // 368px is wider than a phone; let it take what's left instead.
        sx={{ width: { xs: "auto", md: 368 }, flex: { xs: 1, md: "0 1 auto" }, marginRight: 2 }}
        onChange={(e) => setSearchKeywords(e.target.value)}
      />
      <Button
        size={isMobile ? "small" : "medium"}
        startIcon={<Iconify icon="eva:plus-fill" />}
        variant="contained"
        onClick={handleAddMember}
        disabled={!company?.isActive}
        sx={isMobile ? { flexShrink: 0 } : undefined}
      >
        Add
      </Button>
    </Stack>
  );
}
